var site_logo =  require("../assets/logo/site-logo.jpg");

const logos = {
  site_logo
};
export default {
  ...logos
};
